<div [class]="containerClasses()" [style]="gridStyle()">
  @for (option of options(); track option.value) {
  <label
    class="radio-card"
    [class.is-list-layout]="layout() === 'list'"
    [class.is-selected]="option.value === value()"
    [class.is-disabled]="isDisabled()"
  >
    <!-- Visually hidden but accessible radio input -->
    <input
      type="radio"
      class="sr-only"
      [name]="'radio-group-' + this"
      [value]="option.value"
      [checked]="option.value === value()"
      [disabled]="isDisabled()"
      (change)="selectOption(option.value)"
    />

    <div class="flex-grow">
      <div class="flex items-center gap-3">
        @if (option.icon) {
        <lucide-icon [name]="option.icon" class="card-icon"></lucide-icon>
        }
        <span class="card-label">{{ option.label }}</span>
      </div>
      @if (option.description) {
      <div class="description-wrapper">
        <app-text
          color="muted"
          class="description-text"
          [class.is-expanded]="expandedState()[option.value]"
          appCheckOverflow
          (overflows)="onOverflowChange($event, option.value)"
          >{{ option.description }}</app-text
        >
        <!--
          Show the button if:
          1. We are in list layout.
          2. AND (the text is overflowing OR it's already expanded).
          This ensures the "Read Less" button is visible after clicking.
        -->
        @if (layout() === 'list' && (isOverflowing()[option.value] ||
        expandedState()[option.value])) {
        <button
          type="button"
          class="read-more-button"
          (click)="toggleExpand($event, option.value)"
        >
          {{ expandedState()[option.value] ? "Read Less" : "Read More" }}
        </button>
        }
      </div>
      }
    </div>

    <!-- Custom radio indicator -->
    <div class="radio-indicator">
      <div class="radio-indicator-dot"></div>
    </div>
  </label>
  }
</div>
